type SanctuaryEntryScreenProps = {
  onEnter: () => void;
  onSuccess: () => void;
};

export default function SanctuaryEntryScreen({
  onEnter,
}: SanctuaryEntryScreenProps) {

  return (
    <main className="entry-container">
      <header className="entry-header">
        <div className="entry-brand">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo-small"
          />

          <div>
            <div className="entry-brand-name">Calm But Capable</div>
            <div className="entry-brand-subtitle">The Sanctuary</div>
          </div>
        </div>

        <button className="entry-login-button" onClick={onEnter}>
          Login
        </button>
      </header>

      <section className="entry-card">
        <div className="entry-logo-wrap">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo"
          />
        </div>

        <p className="entry-eyebrow">Calm But Capable presents</p>

        <h1 className="entry-title">The Sanctuary</h1>

        <p className="entry-tagline">Continuing tools and support for continuing progress.</p>

       <p className="entry-subtitle">
        Sanctuary helps you understand what is stopping you making progress,
        identify one achievable next step and develop the tools you need to
        keep moving forward across changing goals and circumstances.
       </p>

        <p className="entry-workshop">
          You do not need to complete the workshop or read the book before joining.
          Begin at the stage that is right for you.
        </p>
      </section>

      <p className="entry-transition">
        Modern life creates constant mental noise. The Sanctuary is designed
        to help you slow things down, regain clarity, and move forward more calmly.
      </p>
     <div className="entry-content">
     <section className="entry-section">
     <h2 className="entry-section-title">Who The Sanctuary Is For</h2>
    
      <div className="entry-feature-list">
    <div className="entry-feature">
      You feel capable, but life often feels mentally cluttered.
    </div>

    <div className="entry-feature">
      You struggle knowing where to begin, even with important tasks.
    </div>

    <div className="entry-feature">
      You juggle too many responsibilities and constantly switch focus.
    </div>

    <div className="entry-feature">
      You often know what you want to do, but struggle to maintain momentum consistently.
    </div>

    <div className="entry-feature">
      You want sustainable progress without constant pressure and burnout.
    </div>
  </div>
</section>

<section className="entry-section sanctuary-membership-section">
  <p className="entry-eyebrow">Choose your membership</p>
  <h2 className="entry-section-title">One membership. Two ways to join.</h2>

  <div className="sanctuary-price-grid">
    <article className="sanctuary-price-card">
      <p className="public-card-label">Flexible membership</p>
      <h3>Monthly</h3>
      <p className="sanctuary-price">£30 <span>/ month</span></p>
      <p>Continue for as long as Sanctuary remains useful to you.</p>
      <a
        className="entry-button entry-button-link"
        href="https://buy.stripe.com/00weVdftZ7tobJx2ji7wA01"
      >
        Join monthly
      </a>
    </article>

    <article className="sanctuary-price-card sanctuary-price-card--annual">
      <p className="sanctuary-best-value">Best value — save £61</p>
      <p className="public-card-label">Annual membership</p>
      <h3>Yearly</h3>
      <p className="sanctuary-price">£299 <span>/ year</span></p>
      <p>Pay once for twelve months of continuing access.</p>
      <div className="sanctuary-founder-offer">
        <strong>First 50 founding members</strong>
        <span>£249 for the first year with code FIRST50</span>
        <small>Renews at £299 per year unless cancelled.</small>
      </div>
      <a
        className="entry-button entry-button-link"
        href="https://buy.stripe.com/bJe9AT0z5eVQbJxe207wA02"
      >
        Join annually
      </a>
    </article>
  </div>

  <p className="entry-small-print sanctuary-checkout-note">
    Secure checkout is provided by Stripe. Promotion codes can be entered at checkout.
  </p>
</section>

<section className="entry-section">
  <h2 className="entry-section-title">What Membership Helps You Do</h2>

  <div className="entry-steps">
    <div className="entry-step">
      <span className="entry-step-number">1</span>
      Understand what is stopping you making progress.
    </div>

    <div className="entry-step">
      <span className="entry-step-number">2</span>
      Develop yourself or reduce the step until you and the task meet.
    </div>

    <div className="entry-step">
      <span className="entry-step-number">3</span>
      Build a personal Toolkit you can reuse across different areas of life.
    </div>
  </div>
</section>
</div>
    </main>
  );
}
